<div class="sidebar-cover" [class.active]="isCollapsed" (click)="toggleSidebar()"></div>
<aside class="sidebar scroll" [class.active]="isCollapsed">
    <shared-sidebar-menu-item *ngFor="let item of sidebar" [menu-item]="item">
    </shared-sidebar-menu-item>
</aside>